export default {
  name: "Google",
  image: "/images/google.svg",
  url: "https://developers.google.com/identity/gsi/web/guides/overview",
  match: [{ iss: "https://accounts.google.com" }],
  claims: {},
};
